import type { ViewerConfig } from '../types'

export const viewer: ViewerConfig = {
  cameraPosition: [112.7, 148.64, 359.27],
  minDistance: 100,
  maxDistance: 400,
  minAzimuthAngle: -Math.PI / 10,
  maxAzimuthAngle: Math.PI / 2 - 0.5,
  minPolarAngle: Math.PI / 2.5,
  maxPolarAngle: Math.PI / 2,
  target: [0, 40, 0],
  getShadowManXPosition: (width: number) => -width / 2 - 50,
}
